/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import { Scrollbars } from 'react-custom-scrollbars-2';
import React, {
  //useState,
  //useCallback,
  useRef
} from 'react';

const withScrollbar = (Component) => {
  const Wrapper = React.memo((props) => {
    //const [stateScrollTop, setStateScrollTop] = useState(0);
    const childRef = useRef(null);

    /*
    const onScrollStart = useCallback(() => {
      if (childRef.current) {
        const { scrollTop } = childRef.current.getValues();
        const deltaY = Math.abs(scrollTop - stateScrollTop);
        if (deltaY > 100) {
          childRef.current.scrollTop(stateScrollTop);
        }
      }
    }, [childRef, stateScrollTop]);

    const handleUpdate = useCallback(() => {
      if (childRef.current) {
        const { scrollTop } = childRef.current.getValues();
        setStateScrollTop(scrollTop);
      }
    }, [childRef]);
    */

    return (
      <Scrollbars
        ref={childRef}
        style={{
          height: '440px',
          overflow: 'hidden',
          position: 'relative',
        }}
        //onScrollStart={onScrollStart}
        //onUpdate={handleUpdate}
        renderTrackHorizontal={() => {
          return <div />;
        }}
        renderThumbHorizontal={() => {
          return <div />;
        }}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <Component {...props} />
      </Scrollbars>
    );
  });

  return Wrapper;
};

export default withScrollbar;
